import React from 'react';
import style from 'acscp/components/bookings/flownBookingLink.module.scss';
import { Background, Row } from 'acscp/components/common/row';
import { ArrowIcon } from 'acscp/components/common/icons/arrowIcon';
import { formatBookingsFilter } from 'acscp/components/common/helpers/formatBookingFilter';
import { BookingsFilter } from 'acscp/store';
import { HashLink } from 'react-router-hash-link';

export const FlownBookingsLink: React.FunctionComponent = () => {
    return (
        <HashLink to={'/tripFlown'}>
            <Row
                background={Background.Grey}
                className={style.Row}
            >
                <div className={style.RowText} id={'flownBookingLink'}>
                    <ArrowIcon />
                    {formatBookingsFilter(BookingsFilter.Flown)}
                </div>
            </Row>
        </HashLink>
    );
};
